import {
  Box,
  Button,
  Input,
  SimpleGrid,
  Text,
  Progress,
  Stat,
  StatHelpText,
  StatArrow,
  Skeleton
} from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Footer } from "../../components/Footer";
import { ProductPageCard } from "../../components/ProductPageCard";
import { api } from "../../services/api";
import { theme } from "../../styles/theme";
import { BsDash, BsPlus } from 'react-icons/bs'
import Navbar from "../../components/Navbar";
import { CartContext } from "../../Context/CartContext";
import { AddToCartPopUp } from "../../components/AddToCartPopUp";
import { calculateDeliveryPeriod } from "../../services/deliveryPeriodCalculation";
export function Product() {
  const [productId, setProductId] = useState("")
  const { product_type, product_name } = useParams();
  const [product, setProduct] = useState({})
  const [productType, setProductType] = useState({})
  const [batch, setBatch] = useState({})
  const [prices, setPrices] = useState([])
  const [quantity, setQuantity] = useState(1)
  const [amountAlreadyPurchased, setAmountAlreadyPurchased] = useState(null)
  const [productPhotoUrl, setProductPhotoUrl] = useState("")
  const [productFlyerUrl, setProductFlyerUrl] = useState("")
  const { showCartPopUp, setShowCartPopUp, handleSetSelectedProduct } = useContext(CartContext)
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [loadingPage, setLoadingPage] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (window.fbq != null) {
        window.fbq('trackCustom', 'Product');
      }
    }
  }, []);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      const remainingTime = calculateTimeRemaining();
      if (remainingTime) {
        setTimeRemaining(remainingTime);
      }
    }, 1000);

    return () => {
      clearInterval(timerInterval);
    };
  }, []);

  function calculateTimeRemaining() {
    const now = new Date();
    const expirationTime = new Date(batch.expiration_date);
    const timeDifference = expirationTime - now;
    if (timeDifference <= 0) {
      return null;
    }
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    return { days, hours, minutes, seconds };
  }

  function handleIncrement(e) {
    e.preventDefault()
    setQuantity(quantity + 1)
  }

  function handleDecrement(e) {
    e.preventDefault()
    if (quantity > 1) {
      setQuantity(quantity - 1)
    }
  }

  function finalPrice() {
    if (!product || prices?.length === 0) {
      return 0;
    }
    const sortedPrices = prices?.sort((a, b) => a.unity - b.unity);
    let selectedPrice = sortedPrices[0];
    for (let i = 0; i < sortedPrices.length; i++) {
      if (quantity >= sortedPrices[i].unity) {
        selectedPrice = sortedPrices[i];
      } else {
        break;
      }
    }
    const calculatedPrice = selectedPrice.price_per_unity * quantity * product?.quantity_per_box;
    return calculatedPrice.toFixed(2);
  }

  function unityPrice() {
    if (!product || !prices || prices.length === 0) {
      return 0;
    }

    const sortedPrices = prices.sort((a, b) => a.unity - b.unity);
    let selectedPrice = sortedPrices[0];

    for (let i = 0; i < sortedPrices.length; i++) {
      if (quantity >= sortedPrices[i].unity) {
        selectedPrice = sortedPrices[i];
      } else {
        break;
      }
    }

    return selectedPrice.price_per_unity;
  }

  function boxPrice() {
    if (!product || !prices || prices.length === 0) {
      return 0;
    }

    const sortedPrices = prices.sort((a, b) => a.unity - b.unity);
    let selectedPrice = sortedPrices[0];

    for (let i = 0; i < sortedPrices.length; i++) {
      if (quantity >= sortedPrices[i].unity) {
        selectedPrice = sortedPrices[i];
      } else {
        break;
      }
    }

    return selectedPrice.price_per_unity * product?.quantity_per_box;
  }

  function totalDiscount() {
    if (!product || prices.length === 0) {
      return 0;
    }
    let selectedPrice;
    for (let i = 0; i < prices.length; i++) {
      if (quantity <= prices[i].unity) {
        selectedPrice = prices[i];
        break;
      }
    }
    if (!selectedPrice) {
      selectedPrice = prices[prices.length - 1];
    }
    const calculatedPrice = selectedPrice.price_per_unity * quantity * product?.quantity_per_box;
    const originalPrice = product?.market_price * quantity * product?.quantity_per_box;
    return (originalPrice - calculatedPrice).toFixed(2);
  }

  useEffect(() => {
    async function fetchProductId() {
      try {
        setLoadingPage(true);
        const productId = await api.get(`/api/v1/products/get_product_id?product_name=${product_name}`);
        setProductId(productId.data.product_id);
        const response = await api.get(`/api/v1/products/${productId.data.product_id}`)
        setProduct(response.data.product)
        setBatch(response.data.batch)
        setPrices(response.data.prices)
        setAmountAlreadyPurchased(response.data.amount_already_purchased)
        setProductPhotoUrl(response.data.product_photo_url)
        setProductFlyerUrl(response.data.product_flyer_url)
        setProductType(response.data.product_type)
        window.scrollTo({ top: 0, behavior: "smooth" });
      } finally {
        setLoadingPage(false);
      }
    }
    setShowCartPopUp(false);
    fetchProductId();
  }, [product_type, product_name]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return date.toLocaleDateString('pt-BR', options);
  };

  const completionPercentage = ((quantity + amountAlreadyPurchased) * 100) / batch?.stock;
  let colorScheme;

  if (completionPercentage < 25) {
    colorScheme = 'red';
  } else if (completionPercentage < 75) {
    colorScheme = 'yellow';
  } else {
    colorScheme = 'green';
  }

  const now = new Date();
  const dayOfWeek = now.getDay();
  const currentHour = now.getHours();
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  return (
    <>
      <Navbar/>
      <Box
        bg="#f8f8f8"
        minH="100vh"
        pt={{ base: "120px", md: "160px" }}
        pb={{ base: "48px", md: "64px" }}
      >
        <Box
          maxW="1400px"
          mx="auto"
          px={{ base: "16px", md: "32px" }}
        >
          {loadingPage && (
            <>
              <Skeleton height={{ base: "28px", md: "38px" }} width={{ base: "240px", md: "380px" }} mb={2} borderRadius="8px" />
              <Skeleton height="18px" width="220px" mb={6} borderRadius="8px" />
              <SimpleGrid columns={{ base: 1, md: 3 }} spacing={0} gap={5} alignItems="flex-start">
                <Skeleton height={{ base: "340px", md: "460px" }} borderRadius="16px" />
                <Skeleton height={{ base: "340px", md: "460px" }} borderRadius="16px" />
                <Skeleton height={{ base: "340px", md: "460px" }} borderRadius="16px" />
              </SimpleGrid>
            </>
          )}
          {!loadingPage && (
          <>
          <Text textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='900' color={theme.colors.primaryGreen}>{product?.name} - {product?.brand}</Text>
          <Text textAlign='start' fontWeight='500' color="rgba(0, 74, 51, 0.7)" fontSize={{base: '14px', md: '16px'}} mt="4px">
            {calculateDeliveryPeriod(batch.id, product, "delivery")}
          </Text>
          <SimpleGrid columns={{base: 1, md: 3}} spacing={0} gap={5} margin='1% auto' alignItems="flex-start">
            <Box
              width={{base: '100%', md: '100%'}}
              order={{base: 1, md: 1}}
            >
              <ProductPageCard
                key={productId}
                id={productId}
                name={product?.name}
                prices={prices}
                brand={product?.brand}
                description={product?.description}
                quantityPerBox={product?.quantity_per_box}
                size={product?.size}
                marketPrice={product?.market_price}
                productType={productType}
                batch={batch}
                productPhotoUrl={productPhotoUrl}
                productFlyerUrl={productFlyerUrl}
                suggestedPriceForSale={product?.suggested_price_for_sale}
              />
            </Box>
            <Box
              borderRadius="16px"
              border={`1px solid rgba(0, 74, 51, 0.08)`}
              width={{base: '100%', md: '100%'}}
              margin={"0 auto"}
              boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
              order={{base: 2, md: 2}}
              bg="white"
              overflow="hidden"
              transition="all 0.3s ease"
              _hover={{
                boxShadow: "0 8px 24px rgba(0, 74, 51, 0.12)",
                borderColor: "rgba(0, 74, 51, 0.16)"
              }}
            >
              <Box
                background={`linear-gradient(135deg, ${theme.colors.primaryGreen} 0%, rgba(0, 74, 51, 0.95) 100%)`}
                borderBottom="none"
              >
                <Text
                  fontSize="20px"
                  fontWeight="900"
                  color="white"
                  padding="16px 20px"
                >
                  Tabela de Preços
                </Text>
              </Box>
              <Box p="20px">
                <Text textAlign='start' fontWeight='600' fontSize="13px" color="rgba(0, 74, 51, 0.7)" mb="16px">{product?.quantity_per_box} unidade(s) por {batch?.unity_of_measurement}</Text>
                <Box display="flex" flexDirection="column" gap="12px">
                  {prices?.map((price, index) => {
                    const discountPercentage = Math.round((100 - ((price.price_per_unity * 100) / product?.market_price)));
                    return (
                      <Box
                        key={index}
                        border={`1px solid rgba(0, 74, 51, 0.08)`}
                        borderRadius="12px"
                        p="14px"
                        bg="rgba(0, 74, 51, 0.02)"
                        transition="all 0.25s ease"
                        _hover={{
                          borderColor: "rgba(0, 74, 51, 0.16)",
                          bg: "rgba(0, 74, 51, 0.04)"
                        }}
                      >
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb="8px">
                          <Box>
                            <Text fontSize="13px" fontWeight="600" color={theme.colors.primaryGreen}>
                              {index === prices.length - 1 ? `${price.unity}+ ${batch?.unity_of_measurement}${price.unity > 1 ? 's' : ''}` : `${price.unity} ${batch?.unity_of_measurement}${price.unity > 1 ? 's' : ''}`}
                            </Text>
                            <Text fontSize="16px" fontWeight="900" color={theme.colors.primaryOrange} mt="2px">
                              {(price.price_per_unity / 1).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}/Un.
                            </Text>
                          </Box>
                          <Box
                            bg={theme.colors.primaryOrange}
                            color="white"
                            borderRadius="8px"
                            px="10px"
                            py="4px"
                            display="flex"
                            alignItems="center"
                            gap="4px"
                            fontWeight="700"
                            fontSize="12px"
                          >
                            ↓ {discountPercentage}%
                          </Box>
                        </Box>
                        <Box display="flex" alignItems="center" gap="2px" mt="4px">
                          <Text fontSize="12px" fontWeight="500" color="rgba(0, 74, 51, 0.7)">
                            Economize: <Text as="span" color={theme.colors.primaryOrange} fontWeight="700">{((product?.market_price) - (price.price_per_unity)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Text>
                          </Text>
                        </Box>
                      </Box>
                    )
                  })}
                </Box>
              </Box>
            </Box>
            <Box order={{base: 0, md: 2}}>
              <Box
                borderRadius="16px"
                border={`1px solid rgba(0, 74, 51, 0.08)`}
                width={{base: '100%', md: '100%'}}
                margin={{base: "0px auto", md: "0px 0px 20px 0px"}}
                height={{base: 'auto', md: 'auto'}}
                boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
                bg="white"
                overflow="hidden"
                p="20px"
                transition="all 0.3s ease"
                _hover={{
                  boxShadow: "0 8px 24px rgba(0, 74, 51, 0.12)",
                  borderColor: "rgba(0, 74, 51, 0.16)"
                }}
              >
                <Box mb="16px" pb="16px" borderBottom="1px solid rgba(0, 74, 51, 0.08)">
                  <Text
                    fontSize="13px"
                    fontWeight="600"
                    color="rgba(0, 74, 51, 0.7)"
                    mb="8px"
                  >
                    Total
                  </Text>
                  <Text
                    fontSize="32px"
                    fontWeight="900"
                    color={theme.colors.primaryOrange}
                  >
                    R${finalPrice()}
                  </Text>
                  <Box display="flex" gap="8px" mt="8px">
                    <Text
                      fontSize="13px"
                      fontWeight="600"
                      color="rgba(0, 74, 51, 0.6)"
                    >
                      {batch?.unity_of_measurement}: <Text as="span" color={theme.colors.primaryGreen} fontWeight="700">R${boxPrice().toFixed(2)}</Text>
                    </Text>
                    <Text
                      fontSize="13px"
                      fontWeight="600"
                      color="rgba(0, 74, 51, 0.6)"
                    >
                      Un.: <Text as="span" color={theme.colors.primaryGreen} fontWeight="700">R${unityPrice().toFixed(2)}</Text>
                    </Text>
                  </Box>
                </Box>

                <Box display="flex" alignItems="center" gap="8px" mb="16px" p="12px" bg="rgba(252, 143, 4, 0.08)" borderRadius="10px" border={`1px solid rgba(252, 143, 4, 0.1)`}>
                  <Box
                    bg={theme.colors.primaryOrange}
                    color="white"
                    borderRadius="6px"
                    px="8px"
                    py="4px"
                    fontWeight="700"
                    fontSize="12px"
                  >
                    {batch && batch.discount_per_centage}% OFF
                  </Box>
                  <Text fontWeight='500' fontSize="12px" color="rgba(0, 74, 51, 0.7)">
                    Desconto no mercado: <Text as="span" textDecoration='line-through' color="rgba(0, 74, 51, 0.5)">{product?.marketPrice?.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Text>
                  </Text>
                </Box>

                <Box mb="16px" pb="16px" borderBottom="1px solid rgba(0, 74, 51, 0.08)">
                  <Text
                    mb="10px"
                    fontSize="13px"
                    fontWeight="600"
                    color={theme.colors.primaryGreen}
                  >
                    Quantidade
                  </Text>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    gap="8px"
                  >
                    <BsDash
                      size={28}
                      weight="fill"
                      cursor="pointer"
                      onClick={(e) => handleDecrement(e)}
                      color={theme.colors.primaryGreen}
                    />
                    <Input
                      type="number"
                      value={quantity}
                      onChange={(e) => setQuantity(parseInt(e.target.value))}
                      flex="1"
                      bg="rgba(0, 74, 51, 0.04)"
                      border={`1px solid rgba(0, 74, 51, 0.08)`}
                      borderRadius="8px"
                      textAlign="center"
                      fontWeight="700"
                      fontSize="16px"
                      color={theme.colors.primaryGreen}
                      _focus={{
                        borderColor: theme.colors.primaryGreen,
                        boxShadow: `0 0 0 3px rgba(0, 74, 51, 0.1)`
                      }}
                    />
                    <BsPlus
                      id="button-plus"
                      size={28}
                      weight="fill"
                      cursor="pointer"
                      onClick={(e) => handleIncrement(e)}
                      color={theme.colors.primaryGreen}
                    />
                  </Box>
                  <Text fontSize="12px" fontWeight="500" color="rgba(0, 74, 51, 0.7)" mt="8px">
                    {quantity} {batch?.unity_of_measurement}{quantity > 1 ? 's' : ''} / {quantity * product?.quantity_per_box} {product?.size}
                  </Text>
                </Box>

                {product.suggested_price_for_sale && (
                  <Box p="12px" bg="rgba(0, 74, 51, 0.04)" borderRadius="10px" border={`1px solid rgba(0, 74, 51, 0.08)`} mb="16px">
                    <Text fontWeight="500" fontSize="12px" color="rgba(0, 74, 51, 0.7)">
                      Sugestão de revenda
                    </Text>
                    <Text fontWeight="700" fontSize="16px" color={theme.colors.primaryOrange} mt="4px">
                      R${product?.suggested_price_for_sale.toFixed(2)}
                    </Text>
                  </Box>
                )}

                <Button
                  width="100%"
                  mb="12px"
                  bg={theme.colors.primaryGreen}
                  color={theme.colors.primaryOrange}
                  borderRadius="16px"
                  border="none"
                  fontWeight="900"
                  fontSize="15px"
                  py="6"
                  transition="all 0.25s ease"
                  _hover={{
                    bg: theme.colors.primaryOrange,
                    color: theme.colors.primaryGreen,
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 20px rgba(0, 74, 51, 0.2)"
                  }}
                  onClick={(e) => handleSetSelectedProduct(e, product, batch, finalPrice(), quantity)}
                >
                  ADICIONAR AO CARRINHO
                </Button>
              </Box>
              {product.customer_review && !product.customer_review === null && !isMobile && (
                <Box textAlign='center' marginTop={{ base: "20px", md: "0px" }}>
                  <div dangerouslySetInnerHTML={{ __html: product.customer_review }} />
                </Box>
              )}
            </Box>
          </SimpleGrid>
          {showCartPopUp && <AddToCartPopUp />}
          {product.customer_review && !product.customer_review === null  && isMobile  && (
            <Box textAlign='center' marginTop={{base: "20px", md: "0px"}}>
              <div dangerouslySetInnerHTML={{ __html: product?.customer_review }} />
            </Box>
          )}
          </>
          )}
        </Box>

      </Box>
      <Footer />
    </>
  )
}
